export default __webpack_public_path__ + "static/media/Libby 9781408331514.9689eede.jpg";